import { get, put, post, del, upload } from '@api/request';

/* Party API */

export const fetchPartyTypes = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/codes?caseType=litigation&type=party&name=partyType`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchAgentAuths = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/codes?caseType=litigation&type=party&name=partyAgentAuth`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchParties = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/party`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertParty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/party`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateParty = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchPartyFiles = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPartyFile = async (
  { litigationService },
  authenticationToken,
  { partyID, s3ID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPartyCases = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/cases`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPartyFile = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deletePartyFile = async (
  { litigationService },
  authenticationToken,
  { payload, partyID, s3ID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadPartyFile = async (
  { litigationService },
  authenticationToken,
  { partyID, s3ID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

/* CAD Party API */

export const fetchCadParties = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/cadparty`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCadParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertCadParty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/cadparty`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateCadParty = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateCadPartyPhone = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}/phone`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const activateCadParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}/active`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deactivateCadParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}/deactive`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deleteCadParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/cadparty/${partyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

/* CAD Party Associations API */

export const fetchCadPartyAssociations = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/cadpartyassoc`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCadPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCadPartyAssociationFiles = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCadPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertCadPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/cadpartyassoc`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertCadPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteCadPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteCadPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadCadPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const downloadCadPartyFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/cadpartyassoc/${assocID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const setAppraiserPartyPrimary = async (
  { litigationService },
  authenticationToken,
  { payload, caseAppraiserID },
) => {
  const url = `${litigationService}/litigation/appraiser/${caseAppraiserID}/setprimary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};


export const setCadPartyPrimary = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/cadpartyassoc/setprimary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

/* Plaintiff Party API */

export const fetchPlaintiffParties = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/plaintiffparty`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPlaintiffParty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/plaintiffparty`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updatePlaintiffParty = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/plaintiffparty/${partyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updatePlaintiffPartyPhone = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/plaintiffparty/${partyID}/phone`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const activatePlaintiffParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/plaintiffparty/${partyID}/activate`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deactivatePlaintiffParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/plaintiffparty/${partyID}/deactivate`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deletePlaintiffParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/plaintiffparty/${partyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

/* Plaintiff Party Associations API */

export const fetchPlaintiffPartyAssociations = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/plaintiffpartyassoc`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPlaintiffPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPlaintiffPartyAssociationFiles = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchPlaintiffPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertPlaintiffPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/plaintiffpartyassoc`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertPlaintiffPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deletePlaintiffPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deletePlaintiffPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadPlaintiffPartyFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/plaintiffpartyassoc/${assocID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const setPlaintiffPartyPrimary = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/plaintiffpartyassoc/setprimary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

/* Impartial API */

export const fetchImpartialParties = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/impartialparty`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImpartialParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/impartialparty/${partyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertImpartialParty = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/impartialparty`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateImpartialParty = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/impartialparty/${partyID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateImpartialPartyPhone = async (
  { litigationService },
  authenticationToken,
  { payload, partyID },
) => {
  const url = `${litigationService}/litigation/impartialparty/${partyID}/phone`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteImpartialParty = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/impartialparty/${partyID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

/* Impartial Party Associations API */

export const fetchImpartialPartyAssociations = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/impartialpartyassoc`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImpartialPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImpartialPartyAssociationFiles = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchImpartialPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertImpartialPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/impartialpartyassoc`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertImpartialPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const deleteImpartialPartyAssociation = async (
  { litigationService },
  authenticationToken,
  { assocID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteImpartialPartyAssociationFile = async (
  { litigationService },
  authenticationToken,
  { payload, assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadImpartialPartyFile = async (
  { litigationService },
  authenticationToken,
  { assocID, s3ID },
) => {
  const url = `${litigationService}/litigation/impartialpartyassoc/${assocID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const setImpartialPartyPrimary = async (
  { litigationService },
  authenticationToken,
  { payload, caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/impartialpartyassoc/setprimary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const createPortalUser = async (
  { litigationService },
  authenticationToken,
  { partyID },
) => {
  const url = `${litigationService}/litigation/party/${partyID}/portaluser`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchCaseAppraisers = async (
  { litigationService },
  authenticationToken,
  { caseID },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/appraisers`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCaseAppraiser = async (
  { litigationService },
  authenticationToken,
  { caseAppraiserID },
) => {
  const url = `${litigationService}/litigation/appraiser/${caseAppraiserID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertCaseAppraiser = async (
  { litigationService },
  authenticationToken,
  { caseID, payload },
) => {
  const url = `${litigationService}/litigation/case/${caseID}/appraisers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateCaseAppraiser = async (
  { litigationService },
  authenticationToken,
  { payload, caseAppraiserID },
) => {
  const url = `${litigationService}/litigation/appraiser/${caseAppraiserID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteCaseAppraiser = async (
  { litigationService },
  authenticationToken,
  { caseAppraiserID },
) => {
  const url = `${litigationService}/litigation/appraiser/${caseAppraiserID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
